import { render, staticRenderFns } from "./ScanResult.vue?vue&type=template&id=54de85a0&scoped=true&"
import script from "./ScanResult.vue?vue&type=script&lang=js&"
export * from "./ScanResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de85a0",
  null
  
)

export default component.exports